export const ZOOM_TRANSITION_TIME = 1.2;
export type RendererType = "browser" | "skia";
